import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import playIcon from './youtube_play.png';

export const YoutubePlayButton: FC<{ className?: string }> = ({
  className = '',
}) => {
  return <Image src={playIcon.src} alt="play" className={className} />;
};
